export const financialEducation = {
  // Main section
  financialEducation: 'Financial Education',
  financialEducationDesc: 'Learn about personal finance in an interactive and fun way',
  
  // Additional translations
  level: 'Level',
  keepGoing: 'Keep it up',
  startLearning: 'Start Learning',
  playAndLearn: 'Play and learn',
  searchFinancialTerms: 'Search financial terms',
  learnByPlaying: 'Learn by playing',
  structuredLearning: 'Structured learning',
  practicalCalculators: 'Practical calculators',
  dailyWeeklyChallenges: 'Daily and weekly challenges',
  compareWithOthers: 'Compare with others',
  viewRankings: 'View Rankings',
  viewChallenges: 'View Challenges',
  explore: 'Explore',
  play: 'Play',
  recentActivity: 'Recent Activity',
  yourLearningJourney: 'Your learning journey',
  noActivityYet: 'No activity yet',
  financialDictionary: 'Financial Dictionary',
  dictionaryComingSoon: 'The dictionary will be available soon with hundreds of terms',
  financialGames: 'Financial Games',
  gamesComingSoon: 'Educational games will be available soon',
  financialCourses: 'Financial Courses',
  coursesComingSoon: 'Structured courses will be available soon',
  financialSimulators: 'Financial Simulators',
  simulatorsComingSoon: 'Calculators and simulators will be available soon',
  financialChallenges: 'Financial Challenges',
  challengesComingSoon: 'Daily and weekly challenges will be available soon',
  leaderboardComingSoon: 'The leaderboard will be available soon',
  
  // Navigation
  dashboard: 'Dashboard',
  dictionary: 'Dictionary',
  games: 'Games',
  courses: 'Courses',
  simulators: 'Simulators',
  challenges: 'Challenges',
  leaderboard: 'Leaderboard',
  myProgress: 'My Progress',
  
  // Dashboard
  welcomeBack: 'Welcome Back',
  yourProgress: 'Your Progress',
  totalPoints: 'Total Points',
  currentStreak: 'Current Streak',
  coursesCompleted: 'Courses Completed',
  gamesPlayed: 'Games Played',
  currentLevel: 'Current Level',
  experiencePoints: 'Experience Points',
  daysStreak: '{count} days',
  
  // Dictionary
  searchTerms: 'Search terms...',
  allCategories: 'All Categories',
  allDifficulties: 'All Difficulties',
  favorites: 'Favorites',
  mostViewed: 'Most Viewed',
  recentlyAdded: 'Recently Added',
  allTerms: 'All Terms',
  selectTermToView: 'Select a term to view details',
  views: 'views',
  
  // Dictionary categories
  budgeting: 'Budgeting',
  investment: 'Investment',
  investing: 'Investing',
  debt: 'Debt',
  saving: 'Savings',
  savings: 'Savings',
  retirement: 'Retirement',
  taxes: 'Taxes',
  'real-estate': 'Real Estate',
  general: 'General',
  
  // Dictionary difficulties
  basic: 'Basic',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
  
  // Term details
  definition: 'Definition',
  example: 'Example',
  relatedTerms: 'Related Terms',
  addToFavorites: 'Add to Favorites',
  removeFromFavorites: 'Remove from Favorites',
  share: 'Share',
  
  // Quiz
  quiz: 'Quiz',
  quickQuiz: 'Quick Quiz',
  dailyTrivia: 'Daily Trivia',
  categoryQuiz: 'Category Quiz',
  startQuiz: 'Start Quiz',
  selectCategory: 'Select Category',
  selectDifficulty: 'Select Difficulty',
  question: 'Question',
  of: 'of',
  timeRemaining: 'Time Remaining',
  submit: 'Submit',
  nextQuestion: 'Next Question',
  finishQuiz: 'Finish Quiz',
  
  // Quiz difficulties
  easy: 'Easy',
  medium: 'Medium',
  hard: 'Hard',
  
  // Quiz results
  quizComplete: 'Quiz Complete!',
  yourScore: 'Your Score',
  correctAnswers: 'Correct Answers',
  pointsEarned: 'Points Earned',
  viewExplanations: 'View Explanations',
  tryAgain: 'Try Again',
  shareResults: 'Share Results',
  
  // Games
  budgetChallenge: 'Budget Challenge',
  budgetChallengeDesc: 'Manage a monthly budget and face unexpected events',
  debtDestroyer: 'Debt Destroyer',
  debtDestroyerDesc: 'Learn strategies to eliminate debt effectively',
  investmentTycoon: 'Investment Tycoon',
  investmentTycoonDesc: 'Invest in different assets and maximize your profits',
  financialScenarios: 'Financial Scenarios',
  financialScenariosDesc: 'Make decisions in real-world financial situations',
  
  // Game interface
  startGame: 'Start Game',
  selectDifficultyLevel: 'Select Difficulty Level',
  currentBalance: 'Current Balance',
  month: 'Month',
  score: 'Score',
  makeDecision: 'Make Decision',
  continue: 'Continue',
  gameOver: 'Game Over',
  finalScore: 'Final Score',
  playAgain: 'Play Again',
  
  // Courses
  availableCourses: 'Available Courses',
  myCourses: 'My Courses',
  courseProgress: 'Course Progress',
  startCourse: 'Start Course',
  continueCourse: 'Continue Course',
  lessons: 'Lessons',
  estimatedTime: 'Estimated Time',
  hours: 'hours',
  minutes: 'minutes',
  
  // Course categories
  basics: 'Basics',
  planning: 'Planning',
  
  // Course difficulties
  beginner: 'Beginner',
  
  // Lesson interface
  lessonContent: 'Lesson Content',
  previousLesson: 'Previous Lesson',
  nextLesson: 'Next Lesson',
  completeLesson: 'Complete Lesson',
  lessonCompleted: 'Lesson Completed!',
  watchVideo: 'Watch Video',
  takeQuiz: 'Take Quiz',
  
  // Simulators
  compoundInterestCalculator: 'Compound Interest Calculator',
  compoundInterestDesc: 'Calculate the growth of your investments with compound interest',
  stockInvestmentSimulator: 'Stock Investment Simulator',
  stockInvestmentDesc: 'Simulate stock market investments',
  debtPaymentPlanner: 'Debt Payment Planner',
  debtPaymentDesc: 'Compare strategies to pay off your debts',
  retirementCalculator: 'Retirement Calculator',
  retirementDesc: 'Plan your retirement savings',
  
  // Simulator interface
  inputs: 'Inputs',
  results: 'Results',
  calculate: 'Calculate',
  saveResults: 'Save Results',
  resetCalculator: 'Reset Calculator',
  initialAmount: 'Initial Amount',
  monthlyContribution: 'Monthly Contribution',
  interestRate: 'Interest Rate',
  timeYears: 'Time (years)',
  finalAmount: 'Final Amount',
  totalContributions: 'Total Contributions',
  totalInterestEarned: 'Interest Earned',
  
  // Challenges
  activeChallenges: 'Active Challenges',
  completedChallenges: 'Completed Challenges',
  dailyChallenge: 'Daily Challenge',
  weeklyChallenge: 'Weekly Challenge',
  monthlyChallenge: 'Monthly Challenge',
  challengeProgress: 'Challenge Progress',
  daysRemaining: 'Days Remaining',
  startChallenge: 'Start Challenge',
  challengeCompleted: 'Challenge Completed!',
  claimReward: 'Claim Reward',
  
  // Achievements
  achievements: 'Achievements',
  unlockedAchievements: 'Unlocked Achievements',
  lockedAchievements: 'Locked Achievements',
  recentAchievements: 'Recent Achievements',
  
  // Achievement categories
  quizAchievements: 'Quiz Achievements',
  courseAchievements: 'Course Achievements',
  gameAchievements: 'Game Achievements',
  streakAchievements: 'Streak Achievements',
  masteryAchievements: 'Mastery Achievements',
  
  // Achievement rarities
  common: 'Common',
  rare: 'Rare',
  epic: 'Epic',
  legendary: 'Legendary',
  
  // Leaderboard
  globalLeaderboard: 'Global Leaderboard',
  weeklyLeaderboard: 'Weekly Leaderboard',
  monthlyLeaderboard: 'Monthly Leaderboard',
  rank: 'Rank',
  player: 'Player',
  points: 'Points',
  coursesComplete: 'Courses',
  gamesWon: 'Games Won',
  currentStreakDays: 'Streak',
  myRank: 'My Rank',
  
  // Progress stats
  statistics: 'Statistics',
  overallProgress: 'Overall Progress',
  quizStats: 'Quiz Statistics',
  courseStats: 'Course Statistics',
  gameStats: 'Game Statistics',
  totalQuizzesTaken: 'Total Quizzes Taken',
  averageQuizScore: 'Average Quiz Score',
  lessonsCompleted: 'Lessons Completed',
  totalTimeSpent: 'Total Time Spent',
  gamesCompleted: 'Games Completed',
  averageGameScore: 'Average Game Score',
  
  // Common actions
  start: 'Start',
  complete: 'Complete',
  view: 'View',
  edit: 'Edit',
  delete: 'Delete',
  save: 'Save',
  cancel: 'Cancel',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  close: 'Close',
  review: 'Review',
  readingProgress: 'Reading Progress',
  
  // Status messages
  loading: 'Loading...',
  savingStatus: 'Saving...',
  success: 'Success',
  error: 'Error',
  noResultsFound: 'No results found',
  comingSoon: 'Coming Soon',
  
  // Notifications
  termAddedToFavorites: 'Term added to favorites',
  termRemovedFromFavorites: 'Term removed from favorites',
  quizResultsSaved: 'Quiz results saved',
  lessonProgressSaved: 'Lesson progress saved',
  lessonCompletedSuccess: 'Lesson completed successfully!',
  courseCompletedSuccess: 'Course completed successfully!',
  gameResultsSaved: 'Game results saved',
  simulatorResultsSaved: 'Simulator results saved',
  challengeProgressUpdated: 'Challenge progress updated',
  achievementUnlocked: 'Achievement unlocked!',
  
  // Empty states
  noFavoriteTerms: 'You have no favorite terms',
  noQuizResults: 'You have not completed any quizzes yet',
  noCourses: 'No courses available',
  noActiveChallenges: 'No active challenges',
  noAchievements: 'You have not unlocked any achievements yet',
  
  // Tips and hints
  tip: 'Tip',
  hint: 'Hint',
  didYouKnow: 'Did you know...?',
  
  // Game-specific terms
  event: 'Event',
  decision: 'Decision',
  impact: 'Impact',
  strategy: 'Strategy',
  outcome: 'Outcome',
  
  // Time-related
  seconds: 'seconds',
  day: 'day',
  days: 'days',
  week: 'week',
  weeks: 'weeks',
  months: 'months',
  year: 'year',
  years: 'years',
};
